module.exports = __webpack_public_path__ + "vue/img/img01.9ac61d2e.png";